import { CanActivateFn } from '@angular/router';

export const historyGuard: CanActivateFn = (route, state) => {
  const userStr = sessionStorage.getItem('user');
  if (!userStr) return false;
  try {
    const userProfile = JSON.parse(userStr);
    return !!(userProfile?.security?.historyTab);
  } catch (error) {
    console.error('Error parsing user profile:', error);
    return false;
  }
};
